import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {IProduct, IRoom} from '../model/room.model';

@Injectable({
    providedIn: 'root'
})
export class ProductSearchService {
    private baseUrl;
    public projectId: string;
    private searchUrl: string;

    constructor(protected http: HttpClient) {
        this.baseUrl = environment.serviceUrl;
    }

    loadSearchUrl(): void {
        this.http.get<any[]>(`${this.baseUrl}/bifrost/api/projects/${this.projectId}/configs`, {
            params: {
                key: 'LIVE_PRODUCT_SEARCH_ADAPTOR_URL',
                groupName: 'live'
            },
            observe: 'response'
        }).subscribe(res => {
            this.searchUrl = res.body[0].value;
        });
    }

    search(name: string, categories: any[], room: IRoom, pageNumber: number, itemPerPage: number): Observable<HttpResponse<IProduct[]>> {
        const params = {};
        let categoryIds = '';
        if (name) {
            params['name.contains'] = name;
        }
        const page = 'page';
        params[page] = pageNumber;

        const size = 'size';
        params[size] = itemPerPage;

        if (categories.length > 0) {
            categories.forEach((category, index) => {
                if (index !== 0) {
                    categoryIds += `,${category.id}`;
                } else {
                    categoryIds += `${category.id}`;
                }
            });
        }
        params['catIds.contains'] = categoryIds;

        if (room.ref1) {
            params['ref1'] = room.ref1;
        }
        if (room.ref2) {
            params['ref2'] = room.ref2;
        }
        if (room.ref3) {
            params['ref3'] = room.ref3;
        }
        if (room.ref4) {
            params['ref4'] = room.ref4;
        }
        if (room.ref5) {
            params['ref5'] = room.ref5;
        }
        if (room.ref6) {
            params['ref6'] = room.ref6;
        }
        if (room.ref7) {
            params['ref7'] = room.ref7;
        }
        if (room.ref8) {
            params['ref8'] = room.ref8;
        }
        if (room.ref9) {
            params['ref9'] = room.ref9;
        }
        if (room.ref10) {
            params['ref10'] = room.ref10;
        }
        if (room.shopId) {
            params['shopId'] = room.shopId;
        }
        if (room.user) {
            params['user'] = room.user;
        }
        if (room.tags && room.tags.length > 0) {
            params['tags'] = room.tags.join(',');
        }

        return this.http.get<IProduct[]>(`${this.searchUrl}`, {
            params,
            observe: 'response'
        });
    }
}
